import { MaterialDesignContent } from 'notistack';
import styled from 'styled-components';

import muiTheme from './muiTheme';

const ThemedSnackbar = styled(MaterialDesignContent)(() => ({
  boxShadow: '0px 0.5px 2px rgba(0, 0, 0, 0.04), 0px 1px 4px rgba(0, 0, 0, 0.2)',
  '&.notistack-MuiContent-success': {
    backgroundColor: muiTheme.palette.success.dark,
    color: muiTheme.palette.white,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: muiTheme.palette.error.dark,
    color: muiTheme.palette.white,
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: muiTheme.palette.warning.dark,
    color: muiTheme.palette.white,
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: muiTheme.palette.primary.dark,
    color: muiTheme.palette.white,
  },
}));

export default ThemedSnackbar;
